import { render } from "./FormDataTableV2MV2.vue?vue&type=template&id=158f7210&scoped=true"
import script from "./FormDataTableV2MV2.vue?vue&type=script&lang=js"
export * from "./FormDataTableV2MV2.vue?vue&type=script&lang=js"

import "./FormDataTableV2MV2.vue?vue&type=style&index=0&id=158f7210&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158f7210"]])

export default __exports__